<p-dialog [header]="header" [visible]="true" [modal]="true" [style]="{ width: '660px', maxWidth: '95vw' }"
  [breakpoints]="{ '960px': '80vw', '640px': '95vw' }" [draggable]="false" [styleClass]="'ef-study-options-dialog'"
  [resizable]="false" (visibleChange)="onClose()">

  <div class="ef-study-options-loading" *ngIf="loading()">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <div class="ef-study-options-card" *ngIf="!loading() && studyOptions() as options">
    <div class="field grid">
      <label for="efStudyOptionsName" class="col-fixed font-medium ef-study-options-label">Name<span
          class="ef-study-options-required">*</span></label>
      <div class="col">
        <app-input-text [id]="'efStudyOptionsName'" [isRequired]="true" [isValid]="isNameValid()" [disabled]="busy()"
          [model]="options.name" [maxlength]="maxNameLength"
          (onChangeEvent)="onNameChange($event)"></app-input-text>
        <small class="ef-study-options-error" *ngIf="!isNameValid()">
          The name is required and cannot exceed {{ maxNameLength }} characters.
        </small>
      </div>
    </div>

    <div class="field grid">
      <label for="efStudyOptionsDescription" class="col-fixed font-medium ef-study-options-label">Description</label>
      <div class="col">
        <app-input-textarea [id]="'efStudyOptionsDescription'" [rows]="2" [disabled]="busy()"
          [model]="options.description ?? ''"
          (onChangeEvent)="onDescriptionChange($event)"></app-input-textarea>
        <small class="ef-study-options-error" *ngIf="!isDescriptionValid()">
          The description cannot exceed {{ maxDescriptionLength }} characters.
        </small>
      </div>
    </div>

    <div class="field grid">
      <label for="efStudyOptionsCreatedDate" class="col-fixed font-medium ef-study-options-label">Date</label>
      <div class="col">
        <p-calendar inputId="efStudyOptionsCreatedDate" dateFormat="DD, MM d, yy" appendTo="body" [showIcon]="true"
          [showClear]="true" [disabled]="busy()" [placeholder]="'Default date'" [ngModel]="createdDate()"
          (ngModelChange)="onCreatedDateChange($event)"></p-calendar>
      </div>
    </div>

    <div class="field grid">
      <label for="efStudyOptionsTimeUnit" class="col-fixed font-medium ef-study-options-label">Time entered in<span
          class="ef-study-options-required">*</span></label>
      <div class="col">
        <app-dropdown [id]="'efStudyOptionsTimeUnit'" [isRequired]="true" [isValid]="isTimeUnitValid()"
          [hardDisabled]="busy()" [appendTo]="'body'" [options]="timeUnitOptions" [optionLabel]="'label'"
          [optionValue]="'value'" [model]="options.timeEnteredIn"
          (onChangeEvent)="onTimeUnitChange($event.value)"></app-dropdown>
      </div>
    </div>

    <div class="field grid">
      <label for="efStudyOptionsConcentrationUnit"
        class="col-fixed font-medium ef-study-options-label">Concentration entered in<span
          class="ef-study-options-required">*</span></label>
      <div class="col">
        <app-dropdown [id]="'efStudyOptionsConcentrationUnit'" [isRequired]="true"
          [isValid]="isConcentrationUnitValid()" [hardDisabled]="busy()" [appendTo]="'body'"
          [options]="concentrationUnitOptions" [optionLabel]="'label'" [optionValue]="'value'"
          [model]="options.concentrationEnteredIn"
          (onChangeEvent)="onConcentrationUnitChange($event.value)"></app-dropdown>
      </div>
    </div>

    <div class="field grid">
      <label for="efStudyOptionsComment" class="col-fixed font-medium ef-study-options-label">Comments</label>
      <div class="col">
        <app-input-textarea [id]="'efStudyOptionsComment'" [rows]="3" [disabled]="busy()"
          [model]="options.comment ?? ''" (onChangeEvent)="onCommentChange($event)"></app-input-textarea>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="ef-study-options-footer">
      <app-button [label]="'Cancel'" [outlined]="true" [disabled]="busy()" (onClickEvent)="onClose()"></app-button>
      <app-button [label]="'Save'" [icon]="'pi pi-check'" [loading]="busy()" (onClickEvent)="onSave()"></app-button>
    </div>
  </ng-template>
</p-dialog>
